import { HUBSPOT_APPS_SETTINGS_OAUTH_REDIRECT_PATH } from '@/constants/auth';

/**
 * Get the correct redirect URI path for HubSpot OAuth
 */
export function hubspotRedirectUriPath(isMemberLink: boolean): string {
  return isMemberLink
    ? HUBSPOT_APPS_SETTINGS_OAUTH_REDIRECT_PATH.SINGLE_MEMBER
    : HUBSPOT_APPS_SETTINGS_OAUTH_REDIRECT_PATH.ALL_MEMBERS;
}

/**
 * Get the complete redirect URI for HubSpot OAuth
 */
export function hubspotRedirectUriFull(isMemberLink: boolean): string {
  const url = new URL(hubspotRedirectUriPath(isMemberLink), location.origin);
  return url.toString();
}
